import { Component, Inject } from "@angular/core"
import { CommonModule } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatInputModule } from "@angular/material/input"
import { MatButtonModule } from "@angular/material/button"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"
import { ProductTypeSelectorComponent } from "../../shared/product-type-selector/product-type-selector.component"

export interface ApproveModalData {
  /** Not pre-filled; user must enter. */
  recordingName?: string
  stationId: number
  stationName: string
  preselectedProductTypeIds?: number[]
}

@Component({
  selector: "app-approve-modal",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    ProductTypeSelectorComponent,
  ],
  templateUrl: "./approve-modal.component.html",
  styleUrls: ["./approve-modal.component.css"],
})
export class ApproveModalComponent {
  recordingName: string
  stationName: string
  stationId: number
  preselectedProductTypeIds: number[] = []
  selectedProductTypeIds: number[] = []
  productTypeError = ""
  sending = false

  constructor(
    public dialogRef: MatDialogRef<ApproveModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApproveModalData,
  ) {
    this.recordingName = ""
    this.stationId = data?.stationId ?? 0
    this.stationName = data?.stationName ?? ""
    this.preselectedProductTypeIds = data?.preselectedProductTypeIds ?? []
  }

  onProductTypesChange(ids: number[]): void {
    this.selectedProductTypeIds = ids
    if (ids.length > 0) {
      this.productTypeError = ""
    }
  }

  submit(): void {
    if (!this.recordingName.trim() || this.sending) return
    if (this.selectedProductTypeIds.length === 0) {
      this.productTypeError = "Please assign at least one product type"
      return
    }
    this.sending = true
    this.dialogRef.disableClose = true
    const result = {
      recording_name: this.recordingName.trim(),
      station_id: this.stationId,
      product_type_ids: this.selectedProductTypeIds,
    }
    setTimeout(() => this.dialogRef.close(result), 100)
  }
}
